<!-- 新建标签组 -->
<template>
  <div class="container">
    <el-dialog
      :title="this.diaTitle"
      :visible.sync="show"
      :modal-append-to-body="false"
      width="600px"
      height="400px"
      style="margin-top:5vh;"
      class="dialog-label"
      :close-on-click-modal="false"
      :before-close="cancelHandle"
    >   
      <el-row :gutter="24" >
          <span class="title-tip">标签组名称</span>
          <el-col :span="24">
            <el-input
                placeholder="输入关键词"
                size="small"
                v-model="groupName"
                clearable
                style="width:100%"
                maxlength="15"
                show-word-limit
                >
            </el-input>
          </el-col>
      </el-row>
      <el-row :gutter="24" class="tags-container">
          <span class="tag-tip">标签<span style="color:#aaaaaa;font-weight: normal;">{{groupId!=""?'（修改标签已使用到该标签的活码、客户信息将同步修改）':''}}</span></span>
          <div style="max-height:310px;overflow-y: scroll;" id="tagsArea">
                <el-col :span="24" style="margin-top:10px" v-for="(item,index) in dynamicTags" :key="index">
                    <el-input
                        placeholder="请输入标签内容"
                        size="small"
                        v-model="dynamicTags[index].tagName"
                        clearable
                        style="width:84%;"
                        >
                    </el-input>
                    <el-button size="small" style="border-left:none;border-radius: 0 3px 3px 0;" @click="delHandle(index)">删 除</el-button>
                </el-col>
          </div>
          <el-button type="primary" class="add-btn" size="mini" @click.native="addTagHanle()" icon="el-icon-plus">添加标签</el-button>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelHandle()">取 消</el-button>
        <el-button type="primary" size="small" @click="confirmHandle()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { createTagGroup,createTag,delTag,editTagGroup,editTag} from "@/api/activeCode/activeCode.js"
export default {
  name:"tagsGroupCreate",
  props:["tagGroupDIaVisible","diaTitle","editData"],
  data () {
    return {
        show:false,
        groupName:"", //标签组名
        dynamicTags: [],//增加的标签
        groupId:"",//标签组id （编辑）
		markGroupName:"",
		markTags:[]
    };
  },
  watch: {
      tagGroupDIaVisible(val){
        this.show = val
        this.groupName = ""
        this.dynamicTags = []
        this.groupId = ""
				this.markGroupName = ""
				this.markTags = JSON.parse(JSON.stringify(this.dynamicTags))
        if(val&&this.editData!=null){
            this.groupName = this.editData.groupName
						this.markGroupName = this.editData.groupName
            this.groupId = this.editData.groupId
            let tags = this.editData.hmcActivityTagList
            if(tags.length != 0){
                tags.map(v=>{
                    this.dynamicTags.push({
                        tagName:v.tagName,
                        tagId:v.tagId
                    })
										this.markTags.push({
                        tagName:v.tagName,
                        tagId:v.tagId
                    })
                })
            }
        }
      }
  },
  methods: {
    cancelHandle(){
			if(this.markGroupName!=this.groupName||JSON.stringify(this.markTags)!=JSON.stringify(this.dynamicTags)){
				this.$confirm('', '', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					message:`<div style="font-size:15px;">数据尚未保存，确定取消？</div>`,
					dangerouslyUseHTMLString:true,
					iconClass:"el-icon-warning",
					customClass:"delete-messege",
					center: true
				}).then(() => {
					this.$emit("cancelHandle")
					done()
				}).catch(()=>{})
			}else{
				this.$emit("cancelHandle")
			}
    },
    successHandle(){
        this.groupName = ""
        this.dynamicTags = []
        this.$emit("confirmHandle")
    },
    confirmHandle(){
        if(!this.groupName.trim()){
            this.$message.warning("请输入标签组名称")
        }else{
            //编辑保存
            if(!!this.groupId){
                let params = {"groupName":this.groupName}
                editTagGroup(this.groupId,params,localStorage.getItem("Authorization")).then((res)=>{
                    if (res.error.code == 200) {
                        if(this.dynamicTags.length!=0){
                            this.dynamicTags.map((v,i)=>{
                                //判断标签名字是否为空
                                if(!!v.tagName.trim()){
                                    //判断是编辑 还是 新建
                                    if(!!v.tagId){
                                        //编辑标签
                                        editTag(v.tagId,{tagName:v.tagName},localStorage.getItem("Authorization")).then((res)=>{
                                            if (res.error.code == 200&&i == this.dynamicTags.length-1) {
                                                this.successHandle()
                                            }
                                        }).catch(err=>{})
                                    }else{
                                        //新建标签
                                        createTag({groupId:this.groupId,tagName:v.tagName},localStorage.getItem("Authorization")).then((res)=>{
                                            if (res.error.code == 200&&i == this.dynamicTags.length-1) {
                                                this.successHandle()
                                            }
                                        }).catch(err=>{})
                                    }
                                }else{
                                    if(i == this.dynamicTags.length-1){
                                        this.successHandle()
                                    }
                                }
                            })
                        }else{
                            this.successHandle()
                        }
                    }
                }).catch(err=>{})
            }else{
                createTagGroup({groupName:this.groupName.trim()},localStorage.getItem("Authorization")).then((res)=>{
                    //创建标签组
                    if(res.error.code==200){
                        let groupId = res.data
                        if(this.dynamicTags.length!=0){
                            let params= {
                                groupId:groupId,
                                tagName:""
                            };
                            for(let i=0;i<this.dynamicTags.length;i++){
                                if(this.dynamicTags[i].tagName.trim()){
                                    params.tagName = this.dynamicTags[i].tagName.trim()
                                    createTag(params,localStorage.getItem("Authorization"))
                                    .then((res)=>{
                                        if(res.error.code==200 && i==this.dynamicTags.length-1){
                                            this.successHandle()
                                        }
                                    }).catch((err=>{}))
                                }else{
                                    if(i == this.dynamicTags.length-1){
                                        this.successHandle()
                                    }
                                }
                            }
                        }else{
                            this.successHandle()
                        }
                    }
                }).catch((err)=>{})
            }
        }
    },
    //增加标签
    addTagHanle(){
      this.dynamicTags.push({tagName:""})
      this.$nextTick(() => {
        var container = this.$el.querySelector("#tagsArea");
        container.scrollTop = container.scrollHeight;
    	});
    },
    //删除标签
    delHandle(index){
			if(!!this.groupId){
				this.$confirm('', '', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					message:`<div style="font-size:15px;">确定删除该内容？</div><div style="font-size:12px;color:#999999">（删除后已添加至活码、客户信息中的标签将同步删除）</div>`,
					dangerouslyUseHTMLString:true,
					iconClass:"el-icon-warning",
					customClass:"delete-messege",
					center: true
				}).then(() => {
					if(!!this.dynamicTags[index].tagId){
						delTag(this.dynamicTags[index].tagId,localStorage.getItem("Authorization")).then((res)=>{
							if(res.error.code==200){
								this.dynamicTags.splice(index,1)
								this.$message({
									type: 'success',
									message: '删除成功!'
								});
							}
						}).catch(err=>{})
					}else{
						this.dynamicTags.splice(index,1)
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
					}
				}).catch(() => {});
			}else{
				this.dynamicTags.splice(index,1)
					this.$message({
						type: 'success',
						message: '删除成功!'
				});
			}
    }
  }
}

</script>
<style lang="scss" scoped>
.container{
    /deep/.el-dialog__body{
      padding: 10px 35px;
    }
		/deep/.el-dialog__footer{
			text-align: right !important;
		}
    .tags-container{
        padding-right: 0;
        /deep/.el-input__inner {
          border-right: none;
          border-radius: 3px 0 0 3px;
        }
        /deep/.el-input__inner:focus {
          border-color:#DCDFE6;
          background-color: #ECF5FF;
        }
    }
    .title-tip{
        margin-bottom: 10px;
    }
    .title-tip,.tag-tip{
        font-weight: bold;
        display: inline-block;
        margin-left: 10px;
    }
    .tag-tip{
        // margin-top: 10px;
        padding: 10px 0;
    }
    .add-btn{
        margin:10px 0  0 15px;
    }
}
</style>